module.exports = __webpack_public_path__ + "static/media/phone_scroll_2.572bc3f2.png";